module.exports = __webpack_public_path__ + "img/pic_01.215d3ded.jpg";